import SigliveServiceV1 from 'Service/sigliveServiceV1';

const deleteStudio = async ({ id }) => {
  const { data } = await SigliveServiceV1({ method: 'DELETE', url: `/studio/${id}` });

  return data;
};

export default deleteStudio;
